module.exports = __webpack_public_path__ + "be0f307d97cf9dc921bd46c7b64aa722.svg";